import { ChevronRight } from "lucide-react";
import { TeamLogo } from "../../shared/team-logo";
import { DIVISION_LABELS } from "../../../config/constants";

export const PlayerResult = ({ player, selected, onSelect, onMouseEnter }) => (
  <div
    onClick={() => onSelect({ ...player, _type: "player" })}
    onMouseEnter={onMouseEnter}
    className={`flex items-center gap-2.5 px-3 py-2 cursor-pointer transition-colors border-b border-gray-100 last:border-b-0 ${
      selected ? "bg-blue-50" : "hover:bg-gray-50"
    }`}
  >
    <div className="w-7 h-7 shrink-0">
      <TeamLogo teamId={player.team_id} teamName={player.team_name} size="w-7 h-7" />
    </div>
    <div className="flex-1 min-w-0">
      <div className="text-sm font-medium text-gray-900 truncate">{player.player_name}</div>
      <div className="text-xs text-gray-500 truncate">
        {[player.team_name, DIVISION_LABELS[player.division] ?? player.conference]
          .filter(Boolean)
          .join(" · ")}
      </div>
    </div>
    <ChevronRight className="w-3.5 h-3.5 text-gray-300 shrink-0" />
  </div>
);
